<template>
  <section v-loading="loading" class="attachment-phlebioOrders">
    <div class="case-creation__card">
      <div class="case-creation__heading edit-view">
        <div class="title-with-icon">
          <span class="icon">
            <img
              src="@/assets/images/icons/icon-attachments.svg"
              alt="icon"
              class="img-fluid"
            />
          </span>
          <h3 class="title">ATTACHMENTS</h3>
        </div>
      </div>
      <div class="case-creation__body pb-10">
        <div class="attachment-upload">
          <div
            class="attachment-grid"
            v-for="(doc, index) of sortedAttachments"
            :key="index"
          >
            <div class="content">
              <div class="icon">
                <img
                  src="@/assets/images/icons/attachments/attachments_0.svg"
                  alt="icon"
                  class="img-fluid"
                  style="width: 12px"
                />
              </div>
              <div class="text">
                <p>
                  {{
                    doc.metadata && doc.metadata.original_name
                      ? doc.metadata.original_name
                      : ""
                  }}
                </p>
              </div>
            </div>
            <ul class="actions">
              <li>
                <el-button
                  class="upload-button"
                  type="button"
                  @click="onView(doc)"
                >
                  <p>
                    <img
                      class="action-active"
                      src="@/assets/images/icons/actions/view-icon.svg"
                      alt="icon"
                    />
                  </p>
                </el-button>
              </li>
              <li>
                <el-button
                  class="upload-button"
                  type="button"
                  @click="downloadReport(doc)"
                >
                  <p>
                    <img
                      class="action-active"
                      src="@/assets/images/icons/Download_1.svg"
                      alt="icon"
                      style="width: 16px"
                    />
                  </p>
                </el-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "Attachments",
  computed: {
    ...mapGetters("phlebio", ["getSinglePhlebioDetails"]),
    sortedAttachments() {
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.Order_attachments
      ) {
        let attachments = this.getSinglePhlebioDetails.Order_attachments || [];
        return attachments.sort(
          (a, b) => moment(b.created_at) - moment(a.created_at)
        );
      }
      return [];
    },
    ...mapGetters("respiratoryFileUpload", ["getFileDownloadUrl"]),
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async onView(doc) {
      let routerData = this.$router.resolve({
        name: "ViewAttachments",
        params: {
          path: doc.path,
        },
      });
      window.open(routerData.href, "_blank");
    },
    async downloadReport(doc) {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "respiratoryFileUpload/fetchFileDownloadUrl",
          {
            path: "case_attachments/" + doc.path,
          }
        );
        if (this.getFileDownloadUrl) {
          let url = this.getFileDownloadUrl.download_url;
          axios({
            url: url,
            method: "GET",
            responseType: "blob",
          }).then((response) => {
            const href = URL.createObjectURL(response.data);

            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", `${doc.path}`);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          });
        } else {
          errorNotification("Error in downloading report");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.mini-reason-for-change {
  .el-dialog {
    width: 28%;
    height: 210px !important;
    margin-top: 20vh;
  }
}
.attachment-phlebioOrders {
  max-height: 250px;
  min-height: 50px;
  overflow: auto;
  .attachment-upload {
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
    .attachment-grid {
      display: grid;
      grid-template-columns: max-content 25px;
      align-items: center;
      column-gap: 10px;
      margin-bottom: 10px;
      border: 0.5px solid #e0e0e0;
      border-radius: 4px;
      padding: 3px 10px;
      width: 30%;

      .content {
        align-items: center;
        display: grid;
        grid-template-columns: 20px 375px 15%;

        .icon {
          margin-right: 10px;

          img {
            width: 10px;
            margin-bottom: -5px;
          }
        }

        p {
          color: #828282;
          line-height: 18px;
          font-size: 14px;
          color: #828282;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .actions {
        display: flex;
        justify-content: flex-end;

        li {
          &:not(:last-child) {
            margin-right: 5px;
          }

          button {
            margin-top: 1px;
            padding: 0;
            min-height: 0;
            border: none;
            width: 21px;
            height: 21px;

            &.upload-button {
              background-color: transparent;
            }
          }
        }
        .action-active {
          position: relative;
          top: 3px;
        }
      }
    }
  }
}
</style>
